import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { putRequest, deleteRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import waitingImg from '../../../assets/images/waiting_for_candidates.png';
import './ProjectStatusActions.scss';
var ProjectStatusActions = /*#__PURE__*/function (_Component) {
  function ProjectStatusActions(props) {
    var _this;
    _classCallCheck(this, ProjectStatusActions);
    _this = _callSuper(this, ProjectStatusActions, [props]);
    _this.handleSubmitToClora = _this.handleSubmitToClora.bind(_this);
    _this.handleDeleteProject = _this.handleDeleteProject.bind(_this);
    _this.handleRetractSubmission = _this.handleRetractSubmission.bind(_this);
    return _this;
  }
  _inherits(ProjectStatusActions, _Component);
  return _createClass(ProjectStatusActions, [{
    key: "handleSubmitToClora",
    value: function handleSubmitToClora() {
      var _this$props = this.props,
        submitToCloraUrl = _this$props.submitToCloraUrl,
        csrfToken = _this$props.csrfToken;
      return putRequest(submitToCloraUrl, {}, csrfToken).then(function () {
        analyticsTrack('Clicked on Publish', {
          location: 'Project View'
        });
        window.location.href = "".concat(window.location.href, "?published=true");
      });
    }
  }, {
    key: "handleDeleteProject",
    value: function handleDeleteProject() {
      var _this$props2 = this.props,
        projectUrl = _this$props2.projectUrl,
        projectsUrl = _this$props2.projectsUrl,
        csrfToken = _this$props2.csrfToken;
      return deleteRequest(projectUrl, csrfToken).then(function () {
        window.location.href = projectsUrl;
      });
    }
  }, {
    key: "handleRetractSubmission",
    value: function handleRetractSubmission() {
      var _this$props3 = this.props,
        retractSubmissionUrl = _this$props3.retractSubmissionUrl,
        projectUrl = _this$props3.projectUrl,
        csrfToken = _this$props3.csrfToken;
      return putRequest(retractSubmissionUrl, {}, csrfToken).then(function () {
        window.location.href = projectUrl;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        projectStatus = _this$props4.projectStatus,
        editProjectUrl = _this$props4.editProjectUrl,
        searchTalentUrl = _this$props4.searchTalentUrl,
        projectType = _this$props4.projectType,
        proposalState = _this$props4.proposalState,
        invitationsCount = _this$props4.invitationsCount,
        projectInvitationsUrl = _this$props4.projectInvitationsUrl,
        candidateName = _this$props4.candidateName,
        profileUrl = _this$props4.profileUrl;
      if (projectStatus === 'employer_draft') {
        return /*#__PURE__*/React.createElement("div", {
          className: "project-status-actions"
        }, /*#__PURE__*/React.createElement("h2", null, "Submit project draft for review"), /*#__PURE__*/React.createElement("div", {
          className: "mt-12 body-text-2"
        }, "Clora will help you refine your project to succeed on our marketplace."), /*#__PURE__*/React.createElement("div", {
          className: "mt-32 text-center"
        }, /*#__PURE__*/React.createElement("button", {
          id: "submit-to-clora-status-button",
          className: "btn btn-primary",
          onClick: function onClick() {
            return _this2.handleSubmitToClora();
          }
        }, "Submit to Clora")), /*#__PURE__*/React.createElement("div", {
          className: "mt-16 text-center"
        }, /*#__PURE__*/React.createElement("a", {
          id: "edit-project-status-button",
          className: "btn btn-secondary",
          href: editProjectUrl
        }, "Edit Project")), /*#__PURE__*/React.createElement("div", {
          className: "mt-22 text-center"
        }, /*#__PURE__*/React.createElement("button", {
          id: "delete-project-status-button",
          className: "btn btn-grey pt-0 pr-0 pb-0 pl-0",
          onClick: function onClick() {
            if (window.confirm('Are you sure you want to delete this project?')) {
              _this2.handleDeleteProject();
            }
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fas fa-trash-alt me-3"
        }), "Delete Project")));
      }
      if (projectStatus === 'employer_requested_matching' && candidateName !== null) {
        var firstName = candidateName.split(' ')[0];
        return /*#__PURE__*/React.createElement("div", {
          className: "project-status-actions"
        }, /*#__PURE__*/React.createElement("h2", null, "Waiting for", candidateName, "'s proposals."), /*#__PURE__*/React.createElement("div", {
          className: "mt-12 body-text-2"
        }, "You requested to hire", ' ', candidateName, ' ', "for this project. Clora shared this info with them and will contact you shortly with an answer."), /*#__PURE__*/React.createElement("div", {
          className: "mt-32"
        }, /*#__PURE__*/React.createElement("a", {
          id: "profile-button",
          className: "btn btn-primary",
          href: profileUrl
        }, "View ".concat(firstName, "'s Profile"))), /*#__PURE__*/React.createElement("div", {
          className: "mt-16"
        }, /*#__PURE__*/React.createElement("a", {
          id: "edit-project-status-button",
          className: "btn btn-secondary",
          href: editProjectUrl
        }, "Edit Project")));
      }
      if (projectStatus === 'employer_requested_matching' && projectType !== 'open_marketplace') {
        return /*#__PURE__*/React.createElement("div", {
          className: "project-status-actions"
        }, /*#__PURE__*/React.createElement("h2", null, "Clora is reviewing your project"), /*#__PURE__*/React.createElement("div", {
          className: "mt-12 body-text-2"
        }, "Your account manager will set up a call with you to refine this post before making it public to consultants."), /*#__PURE__*/React.createElement("div", {
          className: "mt-22 text-center"
        }, /*#__PURE__*/React.createElement("button", {
          id: "retract-project-status-button",
          className: "btn btn-grey retract-submission pt-0 pr-0 pb-0 pl-0",
          onClick: function onClick() {
            return _this2.handleRetractSubmission();
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fas fa-backward me-3"
        }), "Retract Submission")));
      }
      if (projectStatus === 'employer_requested_matching' && projectType === 'open_marketplace') {
        return /*#__PURE__*/React.createElement("div", {
          className: "project-status-actions"
        }, /*#__PURE__*/React.createElement("h2", null, "Invite talent, wait for proposals"), proposalState === 'no_proposals_submitted' && /*#__PURE__*/React.createElement("div", {
          className: "mt-12 body-text-2"
        }, "0 Proposals in. The more consultants you invite, the more proposals you receive."), proposalState !== 'no_proposals_submitted' && /*#__PURE__*/React.createElement("div", {
          className: "mt-12 body-text-2"
        }, "Search for consultants, connect, and wait for their proposals."), /*#__PURE__*/React.createElement("div", {
          className: "mt-32"
        }, /*#__PURE__*/React.createElement("a", {
          id: "search-talent-status-button",
          className: "btn btn-primary",
          href: searchTalentUrl
        }, "Search Talent")), proposalState === 'no_proposals_submitted' && /*#__PURE__*/React.createElement("div", {
          className: "mt-16"
        }, /*#__PURE__*/React.createElement("a", {
          id: "edit-project-status-button",
          className: "btn btn-secondary",
          href: editProjectUrl
        }, "Edit Project")), invitationsCount > 0 && /*#__PURE__*/React.createElement("div", {
          className: "mt-40"
        }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
          className: "mt-40 body-text-1 demibold"
        }, /*#__PURE__*/React.createElement("a", {
          id: "invitations-project-status-button",
          className: "btn btn-secondary-no-border",
          href: projectInvitationsUrl
        }, /*#__PURE__*/React.createElement("span", {
          className: "invitations"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-user-plus mr-8"
        }), "Invitations"), /*#__PURE__*/React.createElement("span", {
          className: "invitations-count"
        }, invitationsCount, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-angle-right ms-3"
        }))))));
      }
      if (projectStatus === 'clora_matching') {
        return /*#__PURE__*/React.createElement("div", {
          className: "project-status-actions"
        }, /*#__PURE__*/React.createElement("h2", null, "Wait for candidates' proposals."), /*#__PURE__*/React.createElement("div", {
          className: "mt-12 body-text-2"
        }, "Clora is identifying relevant candidates. You'll receive custom proposals from high-fit consultants."), /*#__PURE__*/React.createElement("div", {
          className: "mt-28 text-center"
        }, /*#__PURE__*/React.createElement("img", {
          src: waitingImg,
          alt: "Person sitting",
          className: "waiting-image"
        })));
      }
      return null;
    }
  }]);
}(Component);
ProjectStatusActions.propTypes = {
  projectStatus: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
  proposalState: PropTypes.string.isRequired,
  invitationsCount: PropTypes.number,
  csrfToken: PropTypes.string.isRequired,
  submitToCloraUrl: PropTypes.string.isRequired,
  editProjectUrl: PropTypes.string.isRequired,
  searchTalentUrl: PropTypes.string.isRequired,
  retractSubmissionUrl: PropTypes.string.isRequired,
  projectUrl: PropTypes.string.isRequired,
  projectsUrl: PropTypes.string.isRequired,
  projectInvitationsUrl: PropTypes.string,
  candidateName: PropTypes.string,
  profileUrl: PropTypes.string
};
ProjectStatusActions.defaultProps = {
  invitationsCount: 0,
  projectInvitationsUrl: '',
  candidateName: null,
  profileUrl: null
};
export default ProjectStatusActions;